/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { IActionContext, getUrlSync } from '@msdyn365-commerce/core';
import { ICartState } from '@msdyn365-commerce/global-state';
import { format } from '@msdyn365-commerce-modules/utilities';
// @ts-ignore
import { Cart } from '../../../eden/eden-icons';
import * as React from 'react';

export interface ILdsCartIconProps {
    cartQtyLabel: string;
    cart?: ICartState;
    actionContext: IActionContext;
}

/**
 *
 * CartIcon component.
 * @extends {React.FC<ICartIconComponentProps>}
 */
export const LdsCartIcon: React.FC<ILdsCartIconProps> = props => {
    const { cartQtyLabel, cart, actionContext } = props;
    const cartLink = getUrlSync('cart', actionContext);

    // If there are invoice lines, don't update mini cart item quantity
    const cartItem = cart ? cart.totalItemsInCart : 0;
    const qtyLabel = format(cartQtyLabel, cartItem);

    const style: React.CSSProperties = {
        visibility: cart ? 'visible' : 'hidden'
    };
    const iconStyle: React.CSSProperties = {
        height: '60px',
        verticalAlign: 'middle'
    };
    const iconContainerStyle: React.CSSProperties = {
        lineHeight: '60px',
        paddingRight: '16px',
        height: '60px'
    };
    return (
        <span style={iconContainerStyle} className='msc-cart-icon msc-btn' onClick={() => console.log(cartLink)}>
            <Cart size='1.27rem' style={iconStyle} class='header-icon' />
            <div className='msc-cart-icon__count' aria-hidden style={style}>
                {qtyLabel}
            </div>
        </span>
    );
};
